import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { InstallationFeaturesStore } from '@store';
import {
  ActivateDeactivateCommands,
  Feature,
  FeatureCommands,
  FeatureNames,
  FeaturePropertyKey,
  RoomsStatusProperties,
  SrcCondensateAvoidanceCommands,
  SrcCondensateAvoidanceStatusProperties,
} from '@vi-iot/client/index';
import { Bool } from 'src/app/shared/common/enums';

@Component({
  selector: 'app-src-settings-condensate-avoidance',
  templateUrl: './src-settings-condensate-avoidance.component.html',
  styleUrl: './src-settings-condensate-avoidance.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SrcSettingsCondensateAvoidanceComponent {
  @Input({ required: true }) status: Feature<RoomsStatusProperties, ActivateDeactivateCommands>;
  @Input({ required: true })
  set condensateFeatures(
    value: Feature<SrcCondensateAvoidanceStatusProperties, SrcCondensateAvoidanceCommands>
  ) {
    this._condensateFeatures = value;
    const { commands, properties } = value;
    this.isToggleDisabled =
      (properties.active.value && !commands.deactivate.isExecutable) ||
      (!properties.active.value && !commands.activate.isExecutable);
  }
  _condensateFeatures: Feature<
    SrcCondensateAvoidanceStatusProperties,
    SrcCondensateAvoidanceCommands
  >;
  isToggleDisabled: boolean;
  description: string;
  bool = Bool;
  featurePropertyKey = FeaturePropertyKey;

  constructor(private installationFeaturesStore: InstallationFeaturesStore) {}

  onCondensateToggleChange({ checked }: MatSlideToggle): void {
    const { gatewayId, deviceId } = this._condensateFeatures;

    this.installationFeaturesStore.updateFeature(
      FeatureNames.condensateAvoidance,
      checked,
      FeaturePropertyKey.active,
      null,
      checked ? FeatureCommands.activate : FeatureCommands.deactivate,
      gatewayId,
      deviceId
    );
  }
}
